import { Injectable } from '@angular/core'
import {
  ConverterService,
  Occ,
  OccEndpointsService,
  OccProductAdapter,
  OccRequestsOptimizerService,
  PRODUCT_NORMALIZER,
  ScopedProductData
} from '@spartacus/core'
import { HttpClient } from '@angular/common/http'

@Injectable({
  providedIn: 'root'
})
export class MbOccProductAdapter extends OccProductAdapter {

  constructor (protected http: HttpClient,
              protected occEndpoints: OccEndpointsService,
              protected converter: ConverterService,
              protected requestsOptimizer: OccRequestsOptimizerService) {
    super(http, occEndpoints, converter, requestsOptimizer)
  }

  load (urlEncodedName: string, scope?: string) {
    return this.http.get(this.getEndpoint(urlEncodedName, scope)).pipe(this.converter.pipeable(PRODUCT_NORMALIZER))
  }

  loadMany (products: ScopedProductData[]) {
    const scopedDataWithUrls = products.map(model => ({
      scopedData: model,
      url: this.getEndpoint(model.urlEncodedName, model.scope),
    }))
    return this.requestsOptimizer.scopedDataLoad<Occ.Product>(scopedDataWithUrls).map(scopedProduct => ({
        ...scopedProduct,
        data$: scopedProduct.data$?.pipe(
          this.converter.pipeable(PRODUCT_NORMALIZER)
        ),
      } as ScopedProductData)
    )
  }

  protected getEndpoint (code: string, scope?: string) {
    return this.occEndpoints.buildUrl('product', {
      urlParams: { urlEncodedName: code },
      scope,
    })
  }

  loadProductOnProductCode (productCode: string) {
    return this.http.get(this.getProductByCodeEndpoint(productCode)).pipe(this.converter.pipeable(PRODUCT_NORMALIZER))
  }

  getProductByCodeEndpoint (code: string, scope?: string) {
    return this.occEndpoints.buildUrl('productDetailByCode', {
      urlParams: { productCode: code },
      scope,
    })
  }
}
